import { Injectable } from "@angular/core";
import { ChallengeResult, VariantSignature } from "@model";
import { compareVariantSignatures } from "@helpers";
import { ConfettiService } from "@core";

@Injectable({ providedIn: "root" })
export class ChallengeLastResultService {
  lastResult: ChallengeResult | null = null;
  private _cleanLastResultTimeout!: ReturnType<typeof setTimeout>;

  constructor(private _confettiService: ConfettiService) {}

  setLastResult(challengeResult: ChallengeResult): void {
    this.lastResult = challengeResult;

    if (challengeResult.result === 100) {
      setTimeout(() => {
        this._confettiService.showConfetti(1);
      }, 500);
    }
  }

  getLastResult(signature: VariantSignature): number | null {
    const hasNewResult = this.lastResult && compareVariantSignatures(this.lastResult, signature);

    if (!hasNewResult) return null;

    clearTimeout(this._cleanLastResultTimeout);
    const result = this.lastResult?.result ?? null;
    this._cleanLastResultTimeout = setTimeout(() => {
      this.lastResult = null;
    }, 3000);
    return result;
  }
}
